import { Icon } from '@chakra-ui/react';

export default function SFQuestionMarkCircleFilled(props) {
  return (
    <Icon
      width={20}
      height={21}
      viewBox='0 0 20 21'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M10 20.4102C4.56055 20.4102 0.0390625 15.8887 0.0390625 10.4492C0.0390625 5 4.55078 0.488281 9.99023 0.488281C15.4395 0.488281 19.9609 5 19.9609 10.4492C19.9609 15.8887 15.4492 20.4102 10 20.4102ZM9.79492 12.5391C10.3027 12.5391 10.6152 12.2168 10.6152 11.8164V11.6992C10.6152 11.1328 10.9375 10.7715 11.6406 10.3125C12.6172 9.66797 13.3203 9.08203 13.3203 7.87109C13.3203 6.19141 11.8262 5.30273 10.1074 5.30273C8.36914 5.30273 7.23633 6.11328 6.96289 7.04102C6.91406 7.19727 6.875 7.36328 6.875 7.53906C6.875 7.98828 7.23633 8.23242 7.56836 8.23242C7.91016 8.23242 8.13477 8.06641 8.32031 7.83203L8.49609 7.58789C8.85742 7.00195 9.375 6.66992 10.0488 6.66992C10.957 6.66992 11.5527 7.1875 11.5527 7.94922C11.5527 8.63281 11.1328 8.96484 10.2539 9.58008C9.53125 10.0879 8.98438 10.6152 8.98438 11.6113V11.7383C8.98438 12.2656 9.27734 12.5391 9.79492 12.5391ZM9.77539 15.5371C10.3613 15.5371 10.8691 15.0781 10.8691 14.4922C10.8691 13.9062 10.3711 13.4375 9.77539 13.4375C9.17969 13.4375 8.68164 13.916 8.68164 14.4922C8.68164 15.0684 9.18945 15.5371 9.77539 15.5371Z' />
    </Icon>
  );
}
